export default "__VITE_ASSET__BhDDgATV__"